module.exports = __webpack_public_path__ + "img/t-open-folder.5a54f5d6.png";